import {inject, Signal} from "@angular/core";
import {InterpolationParameters, TranslateService} from "@ngx-translate/core";
import {toSignal} from "@angular/core/rxjs-interop";
import {map} from "rxjs/operators";

export function translate(key: string, interpolationParams?: InterpolationParameters): Signal<string>;
export function translate(key: string[], interpolationParams?: InterpolationParameters): Signal<{ [key: string]: string }>;
export function translate(key: string | string[], interpolateParams?: InterpolationParameters): Signal< string | { [key: string]: string } > {
    return toSignal(inject(TranslateService).get(key, interpolateParams));
}

export function translateArray(key: string[], interpolateParams?: InterpolationParameters): Signal<string[]> {
    return toSignal(inject(TranslateService).get(key, interpolateParams).pipe(map(Object.values)));
}